import { QuestionAnswerResponseJSON } from './Question-Answer-Response.JSON';

export class DisplayRoleResponseJSON {
    roleName: String;
    actorName: String;
    questionsAnswerString: String;
    questionText: String;
    questionAnswerResponseList:QuestionAnswerResponseJSON[]
    constructor(){
        this.roleName= "";
        this.actorName= "";
        this.questionsAnswerString= "";
        this.questionText="";
        this.questionAnswerResponseList = new Array<QuestionAnswerResponseJSON>();
    }
}